
export default {
  props:{
    ticketId:{
      type : String,
      default: '000000'
    },
    orderId:{
      type : String,
      default: '000000'
    },
    placeImg: {
      type: String,
      default: "@/assets/img/placeholders/activity/activity-slider-placeholder.svg"
    },
    placeName: {
      type: String,
      default: 'Place Name'
    },
    placeLocation: {
      type: String,
      default: 'Place Location'
    },
    activityTitle:{
      type: String,
      default: 'Title'
    },
    activityLocation:{
      type: String,
      default: 'Location'
    },
    date: {
      type: String,
      default: 'MMM DD YYYY'
    },
    time: {
      type: String,
      default: 'MM:HH AM'
    },
    duration:{
      type: String,
      default: 'time'
    },
    noOfTicket: {
      type: Number,
      default: 1
    },
    statusCode: {
      type: Number,
      default: 1
    },
    amount: {
      type: Number,
      default: '000'
    },
    qrCode: {
      type: String
    },
    redeemed: {
      type: Boolean
    },
    redeemedDate: {
      type: String
    },
    contactNumberNo: {
      type: String
    }
  },
  methods:{
    checkStatusCodeValid(code){
      if(code == 2 || code == 3){
        return false
      }
      return true
    }
  }

}
